<div>
  <div class="d-flex justify-content-between bg-white ">
    <div></div>

<!--    <img src="assets/logo.png" alt="logo" >-->

  </div>
  <h1 class="text-center">Progress</h1>
 <div class="row">
   <mat-form-field appearance="outline" class="col-md-3 ">
     <mat-label>Select Centre</mat-label>
     <mat-select  [(ngModel)]="selectedCentre" (selectionChange)="fetchChildren($event)">
       <mat-option *ngFor=" let c of (centres$|async) "
                   [value]="c.centreCode">{{c.centreName}} </mat-option>
       <!--      <mat-option  value="All">All Centres</mat-option>-->
     </mat-select>
   </mat-form-field>

   <mat-form-field appearance="outline" class="col-md-3 ">
     <mat-label>Select Child</mat-label>
     <mat-select  [(ngModel)]="selectedChildCode"  >
       <mat-option *ngFor=" let c of (childrenData)"  [ngClass]="{'yellow' : c.isAlloted==false}"
                   [value]="c">{{c.firstName}} {{c.lastName}} </mat-option>
       <!--      <mat-option  value="All">All Centres</mat-option>-->
     </mat-select>
   </mat-form-field>

   <mat-form-field appearance="outline" class="col-md-2">
     <mat-label>Enter a date range</mat-label>
     <mat-date-range-input [rangePicker]="picker" >
       <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
       <input matEndDate placeholder="End date" [(ngModel)]="endDate">
     </mat-date-range-input>
     <mat-hint>dd/MM/yyyy – dd/MM/yyyy</mat-hint>
     <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
     <mat-date-range-picker #picker></mat-date-range-picker>
   </mat-form-field>

   <mat-form-field appearance="outline" class="col-md-2 ">
     <mat-label>Counsellor</mat-label>
     <mat-select  [(ngModel)]="selectedCounsellor" >
       <mat-option [value]="null">All Counsellors</mat-option>
       <mat-option *ngFor=" let c of counsellors$|async  "
                   [value]="c.userName">{{c.userName}} </mat-option>
       <!--      <mat-option  value="All">All Centres</mat-option>-->
     </mat-select>
   </mat-form-field>

<!--   <mat-form-field appearance="outline" class="col-md-3 ">-->
<!--     <mat-label>Select Challenges Faced</mat-label>-->
<!--     <mat-select  [(ngModel)]="selectedChallenges" >-->
<!--       <mat-option *ngFor=" let c of dataSource  "-->
<!--                   [value]="c">{{c.challengesFaced}} </mat-option>-->
<!--       &lt;!&ndash;      <mat-option  value="All">All Centres</mat-option>&ndash;&gt;-->
<!--     </mat-select>-->
<!--   </mat-form-field>-->
   <button  class="col-md-3" mat-mini-fab color="accent" (click)="getData()"><mat-icon>search</mat-icon></button>
   <button  class="mx-2" mat-mini-fab color="accent" (click)="Clear()"><mat-icon>clear</mat-icon></button>

 </div>


  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Progress Report</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <!--      <li>-->
      <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
      <!--          <mat-icon class="col-white" >add</mat-icon>-->
      <!--        </button>-->
      <!--      </li>-->
      <li>
        <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">
          <img src="assets/images/icons/xlsx.png" alt="" />
        </div>
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 " matSort id="excel-table">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->



    <!-- Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Name </th>
      <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name </th>
      <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="sessionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
      <td mat-cell *matCellDef="let element"> {{element.type}} </td>
    </ng-container>
    <!-- Position Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
      <td mat-cell *matCellDef="let element"> {{element?.date.toDate()|date:'dd/MM/yyyy ' }} </td>
    </ng-container>
    <ng-container matColumnDef="challenges">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Challenges Faced </th>
      <td mat-cell *matCellDef="let element"> {{element.challengesFaced}} </td>
    </ng-container>
    <ng-container matColumnDef="intervention">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Intervention </th>
      <td mat-cell *matCellDef="let element"> {{element?.interventions }} </td>
    </ng-container>

    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Submitted By </th>
      <td mat-cell *matCellDef="let element"> {{element?.submittedBy }} </td>
    </ng-container>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4"><span *ngIf="selectedCentre==null"> No Centre Selected</span>
    </tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
<!--    <tr *matNoDataRow class="mat-row">-->
<!--              <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>-->
<!--    </tr>-->


  </table>
  <mat-paginator [length]="100"
                 [pageSize]="10"
                 [pageSizeOptions]="[25,50,100,200,250,500,1000]"
                 aria-label="Select page">
  </mat-paginator>


</div>
